module.exports = __webpack_public_path__ + "assets/img/Exchange_btn.7fc321dd.png";